import qs from 'qs';
import { type IAsyncService } from '../context/IAsyncService.ts';

/**
 * Ritorna l'URL del service, modificato se necessario con la gestione
 * dell'ID servizio.
 */
function getServiceUrl(service: Pick<IAsyncService, 'id' | 'url' | 'type'>) {
  let url = service.url;

  // Check per retrocompatibilità
  if (url.includes('{idServizioEsterno}')) {
    // Sostituiamo il placeholder {idServizioEsterno} con l'id del servizio
    url = url.replace('{idServizioEsterno}', service.id);
  }

  return url;
}

const absoluteUrlRegex = /^([a-z][a-z\d+\-.]*:)?\/\//i;

/**
 * @see https://github.com/axios/axios/blob/c7e0fea78716e86694d5023f8f17d174bf064e8a/lib/helpers/isAbsoluteURL.js#L10
 */
export function isAbsoluteURL(url: string) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return absoluteUrlRegex.test(url);
}

/**
 * 1. Sostituiamo il placeholder {idServizioEsterno} con l'id del servizio
 * 2. In caso siano specificati dei parametri di input nella url del servizio,
 *    li estraiamo per utilizzarli nella chiamata come parametri di query
 *    "statici"
 */
export function parseAsyncServiceUrl(
  service: Pick<IAsyncService, 'id' | 'url' | 'type'>,
) {
  const serviceUrl = getServiceUrl(service);
  const [serviceUrlPath, serviceUrlParams] = serviceUrl.split('?');

  const originalParams = qs.parse(serviceUrlParams ?? '');

  return {
    url: serviceUrlPath,
    originalParams,
  };
}
